module.exports = __webpack_public_path__ + "static/img/pic404.abfaab2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic404.svg
// module id = REA0
// module chunks = 1